import * as types from "../mutationTypes";
import api from '../../serve/api'

export default {
  [types.SET_STONES](state) {
    const filter = state.filters

    filter.currentPage++
    return new Promise((resolve, reject) => {
     state.loading = true
       api.get('stone', { params: filter })
        .then(
          res => {
            // state.stones = res.data.rows
            if (res.data.rows.length > 0) {

              res.data.rows.forEach(el => {
                state.stones.push(el)
              })
            }
            else {
              filter.currentPage--
              state.filters.last_page = true
            }
            state.total = res.data.total
            state.loading = false
            
            resolve(res)
          },
          error => {
            state.loading = false
            console.error(error.response)
            reject(error.response)
          }
        )

    })
  },

  [types.RESET_STONE_FILTERS](state, token) {
    state.filters = {
      currentPage: 0,
      search: token ? token :  ""
    }
  },

  [types.SELECT_STONE](state, value) {
    state.stone_selected = value
  },

  [types.SET_STONE_DETAIL](state, value) {
    state.stone_detail = value
  }
}

